import main from '@/data/main.js'

export default class OrderService{
    private base_url = `${main.BASE_ENDPOINT}/lms_order`

    public async createOrder(token:string | null, course_id:string | undefined) {
        const uri = `${this.base_url}`
        const rawResponse = await fetch(uri,  {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                'course_id': course_id
            })
          })
        const response = await rawResponse.json()
        return response
    }

    public async completeOrder(token:string | null, order_id:string | undefined) {
        const uri = `${this.base_url}/set-status/completed`
        const rawResponse = await fetch(uri,  {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                'order_id': order_id
            })
          })
        const response = await rawResponse.json()
        return response
    }

    public async cancelOrder(token:string | null, order_id:string | undefined) {
        const uri = `${this.base_url}/set-status/cancel`
        const rawResponse = await fetch(uri,  {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                'order_id': order_id
            })
          })
        const response = await rawResponse.json()
        return response
    }

}